<template>
  <div name="swimming">
    <header class="inner-head border-transparent">
      <div class="flex justify-between">
        <h2 class="inner-head-title">Dance</h2>
      </div>
    </header>

    <div class="header-subnav-holder">

      <button
        v-for="path in tabsList"
        :key="path.id"
        type="button"
        class="header-subnav focus:outline-none"
        @click="showPath(path)"
        v-bind:class="[selectedPath.id === path.id ? 'selected' : '']"
      >
        {{ path.name }}
      </button>
    </div>
  
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "swimming",
  props: [],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    showForSchool() {
      return this.currentUser.isSchool == true;
    },
    tabsList() {
      return this.tabs
    }
  },
  data() {
    return {
      tabs: [],
      selectedPath: {},
    };
  },
  created() {
  },
  mounted() {
     this.tabs = [
      {id: 1, name: "Overview", path: "overview"},
      {id: 2, name: "Lessons", path: "documents/lesson"},
      {id: 3, name: "CPD", path: "CPD"},
      {id: 4, name: "Extra Curricular", path: "extra"},
    ]

    this.selectedPath = this.tabs[0]
  },
  methods: {
    showPath(object) { 
      if (this.selectedPath.id === object.id) { return }
      this.selectedPath = object;
      this.$router.push("/dance/" + object.path);
    },
  },
  components: {},
};
</script>

<style scoped>
</style>